import React, { Component } from 'react';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import gtag, { install } from 'ga-gtag';

export default class PreReservation extends Component {
  constructor (props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount () {
    if ("30min.page" === document.domain) {
      ReactGA.initialize('UA-184751599-1');
      ReactGA.pageview(window.location.pathname + window.location.search);

      install('AW-404081375');
      gtag('config', 'AW-404081375');

      ReactPixel.init('750234562329469');
      ReactPixel.pageView();
    }
  }

  send(password) {
    window.location.href = process.env.REACT_APP_PUBLIC_URL + "/mjpm";
  }

  render () {
    return (
   	<div className="sp home">
      <script
        dangerouslySetInnerHTML={{
          __html: `ytag({
            "type": "yss_conversion",
            "config": {
              "yahoo_conversion_id": "1001198670",
              "yahoo_conversion_label": "9vWGCOrTtKcCEMCPk64B",
              "yahoo_conversion_value": "0"
            }
          });`
        }}
      />
      <h2 id="complete">お申し込み完了</h2>
      <div className="content-wrapper">
        <div className="contents">

          <p className="bold">お申し込みが完了いたしました！</p>
          <p>（まだ予約は完了していません）</p>

          <br />
          <p>ハウスキーパーが決定したタイミングで運営より正式なご連絡をさせていただきます。</p>

          <div className="buttons">
            <button onClick={this.send.bind(this)}>TOPに戻る</button>
          </div>
        </div>
      </div>
    </div>
    );
  }
}